import request from '@/utils/axios'

// 电子社保卡状态查询
export function esscCheck (data) {
  return request({
    url: '/usercenter/mobileAPI/user/essc/check',
    method: 'post',
    data: data
  })
}
// 电子社保卡领取奖励
export function esscReceive (data) {
  return request({
    url: '/usercenter/mobileAPI/user/essc/receive',
    method: 'post',
    data: data
  })
}
// 获取任务链接
export function getTaskUrl (appId) {
  return request({
    url: `/manageApp/mobileAPI/app/detail?appId=${appId}`,
    method: 'get'
  })
}
// 获取活动模板 img数组
export function getActivityTemplateImg (code) {
  return request({
    url: `/manageApp/openAPI/img/${code}`,
    method: 'get'
  })
}
// img活动计数及action处理
export function countAppCodeImageForward (id) {
  return request({
    url: `/manageApp/mobileAPI/img/count/${id}`,
    method: 'get'
  })
}
// 查询邮储银行数币红包预约结果
export function queryPSBCDigiccyRedRet (data) {
  return request({
    url: '/payment/mobileAPI/queryDigiccyRedRet',
    method: 'post',
    data: data
  })
}
// 预约数币红包
export function appointPSBCDigiccyRed (data) {
  return request({
    url: '/payment/mobileAPI/appointDigiccyRed',
    method: 'post',
    data: data
  })
}
// 发送验证码
export function apiSendCode (data) {
  return request({
    url: '/usercenter/userAPI/user/captcha/sendSmsByClientId',
    method: 'post',
    data: data
  })
}
// 领取邮储数币优惠券
export function getYcCoupons (data) {
  return request({
    url: '/payment/mobileAPI/getYcCoupons',
    method: 'post',
    data: data
  })
}
// 百样授权检查接口
export function checkBaiYangAuthorize (data) {
  return request({
    url: '/manageApp/mobileAPI/app/url/baiYang/check',
    method: 'post',
    data: data
  })
}
// 百样授权接口
export function baiYangAuthorize (data) {
  return request({
    url: '/manageApp/mobileAPI/app/url/baiYang/auth',
    method: 'post',
    data: data
  })
}
// 获取抽奖活动详情
export function getLotteryInfo (activityId) {
  return request({
    url: `/manageMarket/mobileAPI/lottery/info/${activityId}`,
    method: 'get'
  })
}

// 抽奖
export function getLotteryRes (activityId) {
  return request({
    url: `/manageMarket/mobileAPI/lottery/res/${activityId}`,
    method: 'get'
  })
}

// 获取微信小程序url scheme
export function geWXMiniappScheme (path) {
  return request({
    url: `/usercenter/publicAPI/gxt/schema?path=${path}`,
    method: 'get'
  })
}

// 加油金 - 抽奖活动查询
export function queryOilLuckDrawInfo (data) {
  return request({
    url: '/carbon/mobileAPI/oilLuchDraw/queryOilLuckDrawInfo',
    method: 'post',
    data: data
  })
}

// 加油金 - 抽奖
export function oilLuckDraw (data) {
  return request({
    url: '/carbon/mobileAPI/oilLuchDraw/oilLuckDraw',
    method: 'post',
    data: data
  })
}

// 加油金 - 兑换优惠券
export function oilLuckDrawExchange (data) {
  return request({
    url: '/carbon/mobileAPI/oilLuchDraw/oilLuckDrawExchange',
    method: 'post',
    data: data
  })
}

// 加油金 - 兑换明细
export function queryOilLucKDrawDetail (data) {
  return request({
    url: '/carbon/mobileAPI/oilLuchDraw/queryOilLucKDrawDetail',
    method: 'post',
    data: data
  })
}

// 查询html代码
export function queryHTMLInfo (data) {
  return request({
    url: '/manageApp/mobileAPI/app/url/generateH5',
    method: 'post',
    data: data
  })
}

// 查询国信通开通状态
export function getGXTMemberState (data) {
  return request({
    url: '/usercenter/mobileAPI/gxt/user/checkOpen',
    method: 'get',
    data: data
  })
}

// 开通国信通会员
export function openGXTMember (data) {
  return request({
    url: '/usercenter/mobileAPI/gxt/user/register',
    method: 'get',
    params: data
  })
}

// 工行数币一分钱乘公交活动 - 乘车码优惠活动资格查询
export function queryUserConsumeActivityPartQual (data) {
  return request({
    url: '/qdt-nfc/mobileAPI/ridingcode/queryUserConsumeActivityPartQual',
    method: 'post',
    data: data
  })
}

// 工行数币一分钱乘公交活动 - 乘车码优惠活动资格查询
export function partActivity (data) {
  return request({
    url: '/qdt-nfc/mobileAPI/ridingcode/partActivity',
    method: 'post',
    data: data
  })
}
